<div class="container-fluid">
  <!------------------------------------------------------------------------>
  <div class="row" style="margin-top:35px;margin-bottom:20px;font-weight: bold;font-size: initial">
    <div class="col-sm-2" style="color: blue;">
      <span>{{ 'SALESORDERHISTORY' | translate }}</span>
    </div>
    <div class="col-sm-2" style="color: green;">
      <span>{{ 'TOTAL' | translate }}:</span>
      <span>{{totalValue.totalPatPrice}}</span>
    </div>
    <div class="col-sm-2" style="color: blue;">
      <span>{{ 'PAYED' | translate
        }}:</span><span>{{totalValue.totalPayedValue}}</span>

    </div>
    <div class="col-sm-2" style="color: red;">
      <span>{{ 'REMAINING' | translate
        }}:</span><span>{{totalValue.totalRemaining}}</span>

    </div>
  </div>
  <table class="table table-striped table-bordered ">
    <thead class="theadStyle" style="background-color:#43c2bf;color:white">
      <tr class="text-center">
        <td width="4%">{{ 'SERIAL'| translate }}</td>
        <td width="4%">{{ 'VISITSERIAL'| translate }}</td>
        <td width="12%">{{ 'DATE'| translate }}</td>
        <td width="8%">{{ 'SERVICECODE' | translate }}</td>
        <td width="12%">{{ 'SERVICENAME' | translate }}</td>
        <td width="8%">{{ 'Price'| translate }}</td>
        <td width="8%">{{ 'Paid' | translate }}</td>
        <td width="7%">{{ 'QUANTITY' | translate }}</td>
        <td width="7%">{{ 'USEDQUANTITY' | translate }}</td>
        <td width="7%">{{ 'REMAININGQUANTITY' | translate }}</td>
        <td width="15%">{{ 'BRANCH' | translate }}</td>
      </tr>
    </thead>
    <tbody>
      <!-- (click)="getSalesOrderDetail(item)" -->
      <tr *ngFor="let item of salesOrderList" (click)="getSalesOrderDetail(item)"
        [ngClass]="{'deleted-row' : item.dataStatus == 3, 'table-success' : showDetail == true}" class="text-center">
        <td>
          {{item.serial}}
        </td>
        <td>
          {{item?.visitSerial}}
        </td>
        <td>
          {{item.serviceDate|date:'dd-MM-yyyy'}}
        </td>
        <td>
          {{item.serviceId}}
        </td>
        <td>
          {{item.serviceNameAr}}
        </td>

        <td>
          {{item.patPrice}}
        </td>
        <td>
          {{item.payedValue}}
        </td>
        <td>
          {{item.quantity}}
        </td>
        <td>
          {{item.usedQuantity}}
        </td>
        <td>
          {{item.quantity-item.usedQuantity}}
        </td>
        <td>
          {{translate.currentLang =='ar'? item.branchAr: item.branchEn}}
        </td>
      </tr>
    </tbody>
  </table>

  <hr>

  <table class="table table-striped table-bordered" *ngIf="showDetail">
    <thead class="theadStyle" style="background-color:#43c2bf;color:white">
      <tr class="text-center">
        <td width="8%">{{ 'SERVICECODE' | translate }}</td>
        <td width="12%">{{ 'SERVICENAME' | translate }}</td>
        <td width="7%">{{ 'USEDQUANTITY' | translate }}</td>
        <td width="12%">{{ 'DATE' | translate }}</td>
        <td width="15%">{{ 'BRANCH' | translate }}</td>
        <td width="15%">{{ 'USER' | translate }}</td>

      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of salesOrderDetail" [ngClass]="{'deleted-row' : item.dataStatus == 3}" class="text-center">
        <td>
          {{item.serviceId}}
        </td>
        <td>
          {{translate.currentLang =='ar'? item.serviceNameAr: item.serviceNameEn}}
        </td>
        <td>
          <input type="number" [(ngModel)]="item.usedQuantity">
        </td>
        <td>
          {{item.serviceDate|date:'dd-MM-yyyy'}}
        </td>
        <td>
          {{translate.currentLang =='ar'? item.branchNameAr: item.branchNameEn}}
        </td>
        <td>
          {{item.userName}}
        </td>
      </tr>
    </tbody>
  </table>
  <div class="container-fluid">
    <btns-ctrl appCodes="1" (clicked)="save()"></btns-ctrl>
  </div>
  <!------------------------------------------------------------------------>

</div>